export default __webpack_public_path__ + "static/media/348.25ea9f9a.png";